export const REMOTE_HOSTNAME = process.env.NEXT_PUBLIC_REMOTE_HOSTNAME;

export const HECTO_PARTNER_ID = process.env.NEXT_PUBLIC_HECTO_PARTNER_ID;

export const NAVERPAY_PARTNER_ID = process.env.NEXT_PUBLIC_NAVERPAY_PARTNER_ID;

export const NAVERPAY_CHAINID_A = process.env.NEXT_PUBLIC_NAVERPAY_CHAINID_A;

export const APPLE_CLIENT_ID = process.env.NEXT_PUBLIC_APPLE_CLIENT_ID;

export const KAKAO_REST_API_KEY = process.env.NEXT_PUBLIC_KAKAO_REST_API_KEY;

export const APP_STATSIG = process.env.NEXT_PUBLIC_STATSIG;

export const CHANNEL_PLUGIN_KEY = process.env.NEXT_PUBLIC_CHANNEL_PLUGIN_KEY;

export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

export const AMPLITUDE_API_KEY = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY;

export const KAKAO_PIXEL_ID = process.env.NEXT_PUBLIC_KAKAO_PIXEL_ID;

export const KAKAO_JAVASCRIPT_KEY =
  process.env.NEXT_PUBLIC_KAKAO_JAVASCRIPT_KEY;
